export const MAX_LIKES_COUNT = 99;
export const MAX_LIKES_COUNT_LABEL = '99+';
export const SHOW_CART_POPUP_TIMEOUT = 400;
export const HIDE_CART_POPUP_TIMEOUT = 1500;
